module.exports = __webpack_public_path__ + "img/pin-sensor-light.afb4d779.svg";